import { createTrackedLinkClickHandler } from 'modules/segment/utils';
import { createTrackEvent as trackEvent } from 'utils/segment';

import * as t from '../ducks/actionTypes';
import { IndexPageTemplate } from '../types';

type TrackEvent = (...args: any[]) => Record<string, any>; // NOTE: this fixes ts error until we are able to update our usage of `trackEvent`

/**
 * NOTE: types need to be updated
 */
export const templateIndexSegmentEvents = {
  [t.CREATE_TEMPLATE_RESPONSE]: (trackEvent as TrackEvent)('Template/Created', [
    'templateId',
    'messageMedium',
  ]),
  [t.EXPORT_TEMPLATE_HTML_RESPONSE]: trackEvent(
    'Template/Exported',
    ['templateId', 'triggeredBy'],
    (event: Record<string, any>) => {
      // Add "exportType" key to event
      return { ...event, exportType: 'html' };
    },
  ),
  [t.DELETE_TEMPLATES_RESPONSE]: (trackEvent as TrackEvent)('Template/Deleted', [
    'templateIds',
    'triggeredBy',
  ]),
  [t.COPY_TEMPLATE_RESPONSE]: (trackEvent as TrackEvent)('Template/Cloned', [
    'srcTemplateId',
    'destTemplateId',
    'destProjectId',
    'triggeredBy',
  ]),
};

/**
 * Invoked when a template "edit" link is clicked.
 */
export const trackTemplateLinkClick = createTrackedLinkClickHandler({
  eventName: 'Link Clicked',
  getEventProperties: (clickEvent, template: IndexPageTemplate) => ({
    contentType: 'template',
    contentId: template.id,
    contentName: template.name,
  }),
});

/**
 * Invoked when a template "import" link is clicked.
 */
export const trackTemplateImportButtonClick = createTrackedLinkClickHandler({
  eventName: 'Import Button Clicked',
  getEventProperties: () => ({
    contentType: 'template',
  }),
});
